// @ts-nocheck

import { BoxV2 } from 'sonata-react-components';
import styled from 'styled-components';

export const BoxStyled = styled(BoxV2).attrs(props => ({ className: props.className }))`
  width: auto;
  font-size: 12px;
  font-family: ${props => props.theme.fontRegular};
  color: ${props => props.theme.uiColors.reportingTextColor};

  @media (max-width: 1920px) {
    width: calc(1 / 2 * 100% - (1 - 1 / 2) * 16px);
  }
`;

export const CustomLegendGenderAgeBoxStyle = styled.div`
  margin-top: 16px;
  display: flex;

  @media (max-width: 1920px) {
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 8px;
  }

  .customLegendGenderAge {
    &__row {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
    &__itemBoxXCategory, &__itemBoxYCategory {
      flex-grow: 1;
      line-height: 15px;
      padding-left: 8px;
      padding-right: 15px;
    }

    &__icon {
      font-size: 16px;
      margin-right: 8px;
    }

    &__xValue, &__yValue {
      font-family: ${props => props.theme.fontSemiBold};
      color: ${props => props.theme.uiColors.reportingMetricColor};
      float: right;
    }
  }
`;
